import { Link } from "react-router-dom";
import LoginForm from "../components/auth/LoginForm"; // Relative path
import SocialLogin from "../components/auth/SocialLogin"; // Relative path
import logoSvg from "../assets/images/logo.svg"; // Relative path

const Login = () => {
  return (
    <div className="flex-grow bg-gray-50 py-12">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex items-center justify-center">
          <img
            src={logoSvg}
            alt="Commercial Property LK Logo"
            className="h-12 w-auto"
          />
        </Link>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
          Sign in to your account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Or{" "}
          <Link
            to="/register"
            className="font-medium text-propertylk-blue hover:text-propertylk-darkblue"
          >
            create a new account
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <LoginForm />
          <SocialLogin />
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Looking to list your property in Colombo?
          </p>
          <Link
            to="/register"
            className="mt-2 inline-block text-sm font-medium text-propertylk-blue hover:text-propertylk-darkblue"
          >
            Register as a property owner →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
